import { render, staticRenderFns } from "./BlackGoldBettingPage.vue?vue&type=template&id=016a6270&"
import script from "./BlackGoldBettingPage.vue?vue&type=script&lang=js&"
export * from "./BlackGoldBettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports